import { GET_ETOLL_SENT_STATUS_SUMMARY } from '../actions/types';
import isEmpty from '../validation/is-empty';

const initialState = {
  list: []
}

export default function(state = initialState, action ) {
    switch(action.type) {
        case GET_ETOLL_SENT_STATUS_SUMMARY:
            return {
                ...state,
                list: action.payload
            }
        default:
            return state;
    }
}
